export default {"src":"/sg/_next/static/media/KNEELENGTH.2bee1207.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};